
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M63 130c6.326 0 11.795 3.672 14.392 9H175a7 7 0 010 14H77.391c-2.596 5.329-8.065 9-14.391 9-6.326 0-11.795-3.671-14.391-9H27a7 7 0 010-14h21.608c2.597-5.328 8.066-9 14.392-9zm110-46c8.837 0 16 7.163 16 16s-7.163 16-16 16c-6.326 0-11.795-3.671-14.391-9H27a7 7 0 010-14h131.608c2.597-5.328 8.066-9 14.392-9zm-57-46c6.326 0 11.795 3.672 14.392 9H175a7 7 0 010 14h-44.609c-2.596 5.329-8.065 9-14.391 9-6.326 0-11.795-3.671-14.391-9H27a7 7 0 010-14h74.608c2.597-5.328 8.066-9 14.392-9z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    